document.addEventListener('DOMContentLoaded', () => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const menuDetails = document.querySelectorAll('.header__inline-menu details');

  if (!menuDetails.length) return;

  menuDetails.forEach((item) => {
    const summary = item.querySelector('summary');
    if (!summary) return;

    item.addEventListener('mouseenter', () => {
      if (!desktopQuery.matches) return;
      item.setAttribute('open', '');
    });

    item.addEventListener('mouseleave', () => {
      if (!desktopQuery.matches) return;
      item.removeAttribute('open');
    });

    summary.addEventListener('click', (event) => {
      if (!desktopQuery.matches) return;
      event.preventDefault();
    });
  });
});
